import { useEffect, useState } from 'react';
import { fetchCompany } from './contentApi';

export function useCompany() {
  const [companyInfo, setCompanyInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCompany()
      .then(setCompanyInfo)
      .catch((err) => setError(err.message || 'Erro ao carregar dados da empresa.'))
      .finally(() => setLoading(false));
  }, []);

  return { companyInfo, loading, error };
}
